// extracted by mini-css-extract-plugin
module.exports = {"footerBg":"ch","footerTopLinks":"dh","footerFeedback":"eh","footerSocial":"fh","footerLegalLinks":"gh","footerIconCards":"hh","footerBotCopy":"ih","screenReadersOnly":"jh"};